<template>
  <div class="p-grid">
    <div class="p-col-12" style="margin-bottom: 5px;">
      <Panel
        class="capital"
        header="Filters"
        key="search_key"
        :toggleable="true"
        :collapsed="false"
      >
        <Toolbar class="">
          <template slot="left">
            <div class="p-col-12 p-lg-4">
              <MultiSelect class="p-mr-2 card-input card-multi" id="carparks" 
              v-model="carparks" :options="carpark_list" 
              optionLabel="name" :filter="true" placeholder="Select Carparks"/>
            </div>
            <div class="p-col-12 p-lg-4">
              <date-picker
                placeholder="From ~ To"
                v-model="range_date"
                class="p-mr-2"
                range
                @change="onChangeDate"
              ></date-picker>
            </div>
            <div class="p-col-12 p-lg-2">
              <Button
                id="seven_days"
                label="7 Days"
                class="p-button-outlined p-button-plain p-mr-2 filter-btn"
                @click="filter('seven_days')"
              />
            </div>
            <div class="p-col-12 p-lg-2">
              <Button
                id="thirty_days"
                label="30 Days"
                class="p-button-outlined p-button-secondary p-mr-2 filter-btn"
                @click="filter('thirty_days')"
              />
            </div>
          </template>

          <template slot="right">
            <Button label="Update" :disabled="disabled" class="p-button-success p-mr-2" icon="pi pi-refresh" @click="update" />
            <Button :disabled="disabled" label="Export" class="p-button-default p-mr-2" icon="pi pi-download" @click="exportCSV" />
          </template>
        </Toolbar>
      </Panel>
    </div>
  </div>
</template>

<script>
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import CarParkService from '../../services/CarParkService';
import ReportService from '../../services/ReportService';


export default {
  components: { DatePicker },
  name: "ReportFilter",
  props: {
    report_type: {
      default: {name: "", value: ''},
    },
  },
  data() {
    return {
      disabled: false,
      reportService: null,
      carparkService: null,
      charts_data: null,
      range_date: null,
      carparks: null,
      report_data: null,
      carpark_list: [],		
    };
  },
  methods: {
    clearFilterBtns() {
      let btn_lists = Object.entries(document.getElementsByClassName("filter-btn"));
      btn_lists.forEach((element) => {
        element[1].className = "p-button-outlined p-button-secondary p-mr-2 filter-btn p-button p-component"
      });
    },
    onChangeDate() {
      this.clearFilterBtns();
    },
    filter(key) {
      if (key) {
        this.clearFilterBtns();
        this.range_date = null;
        let selected_btn = document.getElementById(key);
        selected_btn.className = "p-button-outlined p-button-plain p-mr-2 filter-btn p-button p-component"
      }

      var _from = new Date();
      var _to = new Date();
  
      switch(key){
        case "seven_days":
          _from.setDate(_to.getDate() - 6);
          this.range_date = [_from, _to];
          break;

        case "thirty_days":
          _from.setDate(_to.getDate() - 29);
          this.range_date = [_from, _to];
          break;

        default:
          _from.setDate(_to.getDate() - 6);
          this.range_date = [_from, _to];
          break;
      }

    },
    exportCSV() {
      this.disabled = true;
      this.convert_date()
      this.reportService.downloadTable({"carparks": this.carparks, "type": this.report_type.value, "date": this.range_date}).then(response => {
        if (response.status === 200) {
          let blob = new Blob([response.data],{ type:'text/csv;charset=utf-8;'});
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.report_type.value + " " + new Date().toISOString().slice(0, 10) + ".csv";
          link.click();
        }
        this.disabled = false;
      });
    },
    update() {
      this.convert_date()
      this.$emit('update', this.carparks, this.range_date);
    },
    convert_date() {
      if (this.range_date && typeof(this.range_date[0]) === 'object') {
        this.range_date[0] = this.range_date[0].toLocaleDateString('en-US');
        this.range_date[1] =  this.range_date[1].toLocaleDateString('en-US');
      }
    }
  },
  created() {
    this.carparkService = new CarParkService();
    this.reportService = new ReportService();
    this.filter();
    this.carparkService.listCarparks().then(response => this.carpark_list = response.data.carparks.map(carpark => { 
      return {
        "name": carpark.name,
        "code": carpark.id
      }
    }));
    this.update()
  }
};
</script>

<style scoped lang="scss">
.carpark-item {
  display: flex;
  text-transform: capitalize;

  img {
    width: 20px;
    margin-right: 10px;
    max-height: 17px;
  }
}
.p-dropdown,
.p-button,
.mx-datepicker-range {
  width: 100%;
}
.p-toolbar {
  background: unset;
  border: none;
  padding: unset;
}
.card-multi {
  width: 180px;
}

@media (max-width: 1025px) {
  .card-multi {
    width: 100%;
  }
}
</style>
